import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP, DIRECTION_DOWN } from './constants';
import { getKeyFrameModifier, animationModifier } from './modifiers';
var ANIMATION_DURATION = 6000;
var ANIMATION_DELAY = 0;
var LOOP = true;
var CLIENT_RECT = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0
};

var Marquee = /*#__PURE__*/function (_PureComponent) {
  _inherits(Marquee, _PureComponent);

  var _super = _createSuper(Marquee);

  function Marquee() {
    var _this;

    _classCallCheck(this, Marquee);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.container = null;
    _this.scrollItem = null;
    _this.containerBoundingRect = CLIENT_RECT;
    _this.boundingRect = CLIENT_RECT;

    _this.setScrollItemPosition = function () {
      var direction = _this.props.direction;
      var dir = direction.toLowerCase();
      var container = _this.containerBoundingRect;
      var rect = _this.boundingRect;
      var modifier = '';

      switch (dir) {
        case DIRECTION_LEFT:
          modifier = "translate3d(".concat(container.width, "px, 0, 0)");
          break;

        case DIRECTION_RIGHT:
          modifier = "translate3d(-".concat(rect.width, "px, 0, 0)");
          break;

        case DIRECTION_UP:
          modifier = "translate3d(0, ".concat(_this.props.height, "px, 0)");
          break;

        case DIRECTION_DOWN:
          modifier = "translate3d(0, -".concat(rect.height, "px ,0)");
          break;

        default:
          modifier = "translate3d(".concat(rect.width, "px, 0, 0)");
      }

      _this.container.style.transform = modifier;
      _this.container.style.webkitTransform = modifier;
    };

    _this.generateKey = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          direction = _this$props.direction;
      var id = Date.now();
      return "".concat(prefixCls, "-").concat(direction, "-").concat(id).toUpperCase();
    };

    _this.animationLoop = function () {
      var _this$props2 = _this.props,
          direction = _this$props2.direction,
          _this$props2$loop = _this$props2.loop,
          loop = _this$props2$loop === void 0 ? LOOP : _this$props2$loop,
          _this$props2$animatio = _this$props2.animationDuration,
          animationDuration = _this$props2$animatio === void 0 ? ANIMATION_DURATION : _this$props2$animatio,
          _this$props2$animatio2 = _this$props2.animationDelay,
          animationDelay = _this$props2$animatio2 === void 0 ? ANIMATION_DELAY : _this$props2$animatio2;

      var key = _this.generateKey();

      var modifier = getKeyFrameModifier(direction);
      var style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = modifier(_this.getDistance(), key);
      document.getElementsByTagName('head')[0].appendChild(style);
      var animation = animationModifier(animationDuration, loop, animationDelay, key);
      _this.container.style.animation = animation;
      _this.container.style.webkitTransform = animation;
    };

    return _this;
  }

  _createClass(Marquee, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.containerBoundingRect = this.container.getBoundingClientRect();
      this.boundingRect = this.scrollItem.getBoundingClientRect();
      this.setScrollItemPosition();
      this.animationLoop();
    }
  }, {
    key: "getDistance",
    value: function getDistance() {
      var direction = this.props.direction;
      var dir = direction.toLowerCase();

      switch (dir) {
        case DIRECTION_LEFT:
          return this.boundingRect.width;

        case DIRECTION_RIGHT:
          return this.containerBoundingRect.width;

        case DIRECTION_UP:
          return this.boundingRect.height;

        case DIRECTION_DOWN:
          return this.containerBoundingRect.height;

        default:
          return this.boundingRect.width;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          className = _this$props3.className,
          height = _this$props3.height,
          width = _this$props3.width,
          children = _this$props3.children;
      var cls = classnames(prefixCls, className);
      var style = this.props.style;
      style = style || {};
      style.width = width;
      style.height = height;
      return /*#__PURE__*/React.createElement("div", {
        className: cls
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__body"),
        ref: function ref(el) {
          _this2.container = el;
        },
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__content"),
        ref: function ref(el) {
          _this2.scrollItem = el;
        }
      }, children)));
    }
  }]);

  return Marquee;
}(PureComponent);

Marquee.displayName = 'CheckboxGroup';
Marquee.defaultProps = {
  prefixCls: 'za-marquee',
  direction: 'left',
  loop: LOOP,
  animationDuration: ANIMATION_DURATION,
  animationDelay: ANIMATION_DELAY
};
export { Marquee as default };